import Framework, { BaseService } from '@greenville/framework';
import * as constants from '../../../common/constants';
import utils from '../../../common/utils';

export default class AetTopicDeleteService extends BaseService {
  constructor() {
    super(constants.DELETE_AET_TOPIC_DATA, 'AetTopicDeleteStatus');
    this.fetchPayload = null;
  }

  handleEvent(eventName, event) {
    const { payload, headers } = utils.buildRequestPartsFromPayload(event);

    // Get tenantId from payload or headers
    const tenantId = payload.tenantId || headers[constants.BERLIN_TENANT_ID_HEADER];

    // Store fetch payload for refetching after successful deletion
    this.fetchPayload = {
      bookId: payload.bookId,
      pageId: payload.pageId,
      tenantId
    };

    // Send only required fields to delete API
    const deletePayload = {
      pageId: payload.pageId,
      bookId: payload.bookId,
      productModel: payload.productModel,
      topicId: payload.topicId
    };

    return this.getClient('aiadminv2').post(`/cm/topic-aet/delete`, deletePayload, { headers });
  }

  handleResponse(response) {
    const { data } = response;
    if (data.status === 'success') {
      const notification = {
        open: true,
        type: 'success',
        message: 'AET Topic Deleted successfully'
      };
      Framework.getStoreRegistry().getStore('notificationState').set(notification);
      Framework.getStoreRegistry().getStore('aetTopicUtility').setDeleteAetTopicResponse(response.data);

      // Refetch the updated data to show in UI
      if (this.fetchPayload) {
        Framework.getStoreRegistry().getStore('aetTopicUtility').fetchAetTopic(this.fetchPayload);
      }
    }
  }

  handleError(error) {
    // eslint-disable-line class-methods-use-this
    const { response } = error;
    if (response) {
      const { status, data } = response;
      if (status === 401) {
        utils.redirectToLogin();
      }
      if (status === 500 && data && data.error) {
        const notification = {
          open: true,
          message: data.error.message,
          type: 'error'
        };
        Framework.getStoreRegistry().getStore('notificationState').set(notification);
      }
    } else if (error.message === 'timeout of 60000ms exceeded') {
      const notification = {
        open: true,
        message: error.message,
        type: 'error'
      };
      Framework.getStoreRegistry().getStore('notificationState').set(notification);
    }
  }
}
